import Vue from 'vue';

export default [
    {
        pathId: 'sl',
        component: 'support-list',
        title: 'Support',
        icon: 'fa-life-ring',
        size: 'sm',
        reload: true,
        loading: true
    }, {
        pathId: 'st',
        component: 'support-ticket',
        title: 'Ticket',
        icon: 'fa-life-ring',
        size: 'xl',
        props: ['ticketId'],
        reload: true,
        loading: true
    }, {
        pathId: 'stn',
        component: 'support-ticket-new',
        title: 'New Ticket',
        icon: 'fa-envelope-open-text',
        size: 'md'
    }, {
        pathId: 'ss',
        component: 'support-settings',
        title: 'Support Settings',
        icon: 'fa-cog',
        size: 'md',
        reload: true,
        loading: true
    }, {
        pathId: 'scr',
        component: 'support-canned-response',
        title: 'Canned Response',
        icon: 'fa-comment-alt-lines',
        size: 'md',
        props: ['responseId']
    }
];

Vue.component('support-list', () => import('@/cards/support/SupportList'));
Vue.component('support-ticket', () => import('@/cards/support/SupportTicket'));
Vue.component('support-ticket-new', () => import('@/cards/support/SupportTicketNew'));
Vue.component('support-settings', () => import('@/cards/support/SupportSettings'));
Vue.component('support-canned-response', () => import('@/cards/support/SupportCannedResponse'));
